"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const styles_1 = require("./styles");
const Collapse_1 = require("../Collapse");
const Form_1 = require("../Form");
const AccordionContext = (0, react_1.createContext)({
    elements: [],
    toggle: () => null,
});
const Element = (0, react_1.forwardRef)(({ index, title, children, chevronPosition = 'right', keepInactive, className, }, ref) => {
    const { elements, toggle } = (0, react_1.useContext)(AccordionContext);
    const isForm = (0, Form_1.useIsForm)();
    if (index === undefined) {
        throw new Error('Index not passed to AccordionElement, this should be done automatically. It usually means that no Accordion wrapper was provided');
    }
    const open = elements[index];
    const rightSvg = chevronPosition === 'right';
    const chevron = (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsx)(styles_1.Chevron, { "$open": open || undefined, "$right": rightSvg || undefined })), [open, rightSvg]);
    const titleElement = (0, react_1.useMemo)(() => {
        if (typeof title === 'function') {
            return title(open);
        }
        return (0, jsx_runtime_1.jsx)(styles_1.Title, { children: title });
    }, [title, open]);
    const inactive = keepInactive !== null && keepInactive !== void 0 ? keepInactive : Boolean(isForm);
    return ((0, jsx_runtime_1.jsxs)(styles_1.Wrap, Object.assign({ ref: ref, className: className }, { children: [(0, jsx_runtime_1.jsx)(styles_1.Head, Object.assign({ "data-open": open, onClick: () => toggle(index) }, { children: rightSvg ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [titleElement, chevron] })) : chevronPosition === 'none' ? (titleElement) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [chevron, titleElement] })) })), (0, jsx_runtime_1.jsx)(Collapse_1.Collapse, Object.assign({ open: Boolean(open), keepInactive: inactive }, { children: children }))] })));
});
function Accordion({ children, allowMultiple, }) {
    const [elements, setElements] = (0, react_1.useState)(Array.from({ length: (0, react_1.isValidElement)(children) ? 1 : children.length }).map((_) => false));
    const toggle = (0, react_1.useCallback)((index) => setElements((currentElements) => currentElements.map((v, i) => i === index ? !v : allowMultiple ? v : false)), [allowMultiple]);
    const contextValue = (0, react_1.useMemo)(() => ({ elements, toggle }), [elements, toggle]);
    const count = react_1.Children.count(children);
    (0, react_1.useEffect)(() => {
        if (count !== elements.length) {
            setElements(Array.from({ length: count }).map((_, index) => { var _a; return (_a = elements[index]) !== null && _a !== void 0 ? _a : false; }));
        }
    }, [count, elements]);
    return ((0, jsx_runtime_1.jsx)(AccordionContext.Provider, Object.assign({ value: contextValue }, { children: react_1.Children.map(children, (child, index) => child && (0, react_1.cloneElement)(child, { index })) })));
}
exports.Accordion = Accordion;
Accordion.Element = Element;
